import { createGlobalStyle } from 'styled-components';
import { normalize } from 'polished';
import color from './variables/colours';
import typography from './variables/typography';
import spacing from './variables/spacing';

const GlobalStyle = createGlobalStyle`
	${normalize()};

	:root {
		box-sizing: border-box;
	}

	*,
	::before,
	::after {
		box-sizing: border-box;
	}

	html,
	body {
		height: 100%;
		margin: 0;
		padding: 0;
		width: 100%;
	}

	body {
		background-color: ${color.background};
		color: ${color.palette.black};
		font-family: ${typography.fontPrimary};
		font-weight: ${typography.fontWeightRegular};
		font-size: ${typography.defaultFontSize}px;
		line-height: ${typography.lineHeightDefault};

		:focus {
			outline: none;
		}
	}

	a {
		color: ${color.baseLink};
		text-decoration: underline;

		&:visited {
			color: ${color.baseLinkVisited};
		}

		&:hover {
			color: ${color.baseLinkHover};
		}

		&:active {
			color: ${color.baseLinkActive};
		}

		&:focus {
			-moz-box-shadow: 0 0 0 4px ${color.focusBlue};
			-webkit-box-shadow: 0 0 0 4px ${color.focusBlue};
			box-shadow: 0 0 0 4px ${color.focusBlue};
			outline: 4px solid transparent;
			transition: all 0.1s ease-in-out;
		}
	}

	.ontario-text--capitalize::first-letter {
		text-transform: uppercase;
	}
    
    input[type=number] {
      -moz-appearance: textfield;
    }

	.ontario-icon {
		display: inline-block !important;
        width: 24px !important;
        height: 24px !important;
        strokeWidth: 0;
        stroke: currentColor;
        fill: currentColor;
        vertical-align: middle;
        overflow: hidden;
        margin: 0 calc(${spacing.spacing3} / 2) 0 0 !important;
        padding: 0 !important;

		path {
			fill: currentColor;
		}
	}
`;

export default GlobalStyle;
